import { usePermissions } from '@/hooks/usePermissions'

export function useSettingsPermissions() {
  const { puede, esOwner, esAdmin, isLoading } = usePermissions()

  return {
    canViewOrgSettings: puede.verConfiguracion,
    canEditOrgSettings: puede.editarConfiguracion,
    canEditOwnPreferences: true, // All users can edit their own preferences
    isOrgAdmin: esOwner || esAdmin,
    isLoading,
  }
}
